const leaderBoardStyle = {
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    LeftToRight: {
        textAlign: "right",
        direction: "rtl"
    },
    RightToLeft: {
        textAlign: "left",
        direction: "ltr"
    },
    Center:{
        textAlign: "center !important",
    },
    Mine: {
        color: "#000",
        backgroundColor: "#d1d1d1"
    },
    Row: {
        padding: "10px 0px",
        margin: "0px"
    }
};
export default leaderBoardStyle;